module.exports = "<as-breadcrumb items='$ctrl.paths'></as-breadcrumb>\n<div id=\"createCase\">\n        <div class=\"container\">\n            <div class=\"row\">\n                <div class=\"col-md-12 noPadding\">\n                    <div class=\"createCaseContainer\">\n                        <asui-form items=\"$ctrl.form.items\" name=\"$ctrl.form.name\" subject=\"'Create a Support Case'\" on-submit=\"$ctrl.onSubmit()\"></asui-form>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./modules/support/components/support-create-case/supportCreateCase.component.html
// module id = 737
// module chunks = 0